const AWARD_DATE_FORMAT = new Intl.DateTimeFormat('en-GB', {
  day: 'numeric',
  month: 'long',
  year: 'numeric',
  timeZone: 'UTC',
});

/**
 * Formats an ISO `YYYY-MM-DD` date as e.g. `30 July 2026`.
 *
 * Locale and time zone are pinned so the prerendered HTML and the browser
 * always produce the same string, regardless of where either one runs.
 */
export function formatAwardDate(isoDate: string): string {
  return AWARD_DATE_FORMAT.format(new Date(`${isoDate}T00:00:00Z`));
}
